import React from "react";

export default function PageTitle({title}) {
    return (
        <h1 className='txt-bold txt-l mb-m'>
            {title}
        </h1>
    )
}